"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _PARAMS, _NETWORKS;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWalletChainId = exports.networkHasUpdated = exports.switchToNetwork = exports.addNetworksToMetamask = exports.addNetworkToMetamask = exports.addTokensToMetamask = exports.makeAddCeloTokensParams = exports.tokenToParam = exports.makeNetworkParams = exports.MetamaskRPCErrorCode = void 0;
var mini_kit_1 = require("@celo/contractkit/lib/mini-kit");
var constants_1 = require("../constants");
var types_1 = require("../types");
var CELO_PARAMS = Object.freeze({
  chainName: 'Celo',
  testnet: false,
  nativeCurrency: {
    name: 'CELO'
  }
});
var ALFAJORES_PARAMS = Object.freeze({
  chainName: 'Alfajores Testnet',
  testnet: true,
  nativeCurrency: {
    name: 'A-CELO'
  }
});
var BAKLAVA_PARAMS = Object.freeze({
  chainName: 'Baklava Testnet',
  testnet: true,
  nativeCurrency: {
    name: 'B-CELO'
  }
});
var PARAMS = (_PARAMS = {}, _defineProperty(_PARAMS, types_1.ChainId.Mainnet, CELO_PARAMS), _defineProperty(_PARAMS, types_1.ChainId.Alfajores, ALFAJORES_PARAMS), _defineProperty(_PARAMS, types_1.ChainId.Baklava, BAKLAVA_PARAMS), _PARAMS);
// First Class Supported Networks
var NETWORKS = (_NETWORKS = {}, _defineProperty(_NETWORKS, types_1.ChainId.Mainnet, constants_1.Mainnet), _defineProperty(_NETWORKS, types_1.ChainId.Alfajores, constants_1.Alfajores), _defineProperty(_NETWORKS, types_1.ChainId.Baklava, constants_1.Baklava), _NETWORKS);
var MetamaskRPCErrorCode;
(function (MetamaskRPCErrorCode) {
  MetamaskRPCErrorCode[MetamaskRPCErrorCode["AwaitingUserConfirmation"] = -32002] = "AwaitingUserConfirmation";
  MetamaskRPCErrorCode[MetamaskRPCErrorCode["UnrecognizedChainID"] = -32603] = "UnrecognizedChainID";
  MetamaskRPCErrorCode[MetamaskRPCErrorCode["UnknownNetwork"] = 4902] = "UnknownNetwork";
})(MetamaskRPCErrorCode = exports.MetamaskRPCErrorCode || (exports.MetamaskRPCErrorCode = {}));
var makeNetworkParams = function makeNetworkParams(info, CELO) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _a, _yield$Promise$all, _yield$Promise$all2, symbol, decimals;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Promise.all([CELO.symbol(), CELO.decimals()]);
        case 2:
          _yield$Promise$all = _context.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
          symbol = _yield$Promise$all2[0];
          decimals = _yield$Promise$all2[1];
          return _context.abrupt("return", {
            chainId: "0x".concat(info.chainId.toString(16)),
            chainName: (_a = PARAMS[info.chainId].chainName) !== null && _a !== void 0 ? _a : info.name,
            nativeCurrency: {
              name: PARAMS[info.chainId].nativeCurrency.name,
              symbol: symbol,
              decimals: decimals
            },
            rpcUrls: [info.rpcUrl],
            blockExplorerUrls: [info.explorer],
            iconUrls: ["https://celoreserve.org/assets/tokens/".concat(symbol, ".svg")] // unfortunately unused
          });
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};
exports.makeNetworkParams = makeNetworkParams;
var tokenToParam = function tokenToParam(token) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var _yield$Promise$all3, _yield$Promise$all4, symbol, decimals, name;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return Promise.all([token.symbol(), token.decimals(), token.name()]);
        case 2:
          _yield$Promise$all3 = _context2.sent;
          _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 3);
          symbol = _yield$Promise$all4[0];
          decimals = _yield$Promise$all4[1];
          name = _yield$Promise$all4[2];
          return _context2.abrupt("return", {
            type: 'ERC20',
            options: {
              address: token.address,
              name: name,
              symbol: symbol,
              decimals: decimals,
              image: "https://reserve.mento.org/assets/tokens/".concat(symbol, ".svg")
            }
          });
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
};
exports.tokenToParam = tokenToParam;
var makeAddCeloTokensParams = function makeAddCeloTokensParams(tokens) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", Promise.all(Object.values(tokens).map(exports.tokenToParam)));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
};
exports.makeAddCeloTokensParams = makeAddCeloTokensParams;
var addTokensToMetamask = function addTokensToMetamask(ethereum, tokens) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var tokenParams, added;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, exports.makeAddCeloTokensParams)(tokens);
        case 2:
          tokenParams = _context4.sent;
          _context4.next = 5;
          return Promise.all(tokenParams.map(function (params) {
            return ethereum === null || ethereum === void 0 ? void 0 : ethereum.request({
              method: 'wallet_watchAsset',
              params: params
            });
          }));
        case 5:
          added = _context4.sent.every(Boolean);
          return _context4.abrupt("return", added);
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
};
exports.addTokensToMetamask = addTokensToMetamask;
var addNetworkToMetamask = function addNetworkToMetamask(ethereum, networkConfig) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var _b, CELO, tokens, code;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          if (!Object.keys(NETWORKS).includes(networkConfig.chainId.toString())) {
            _context5.next = 24;
            break;
          }
          _context5.next = 4;
          return (0, mini_kit_1.newKit)(networkConfig.rpcUrl).celoTokens.getWrappers();
        case 4:
          _b = _context5.sent;
          CELO = _b.CELO;
          tokens = __rest(_b, ["CELO"]);
          if (!(ethereum === null || ethereum === void 0)) {
            _context5.next = 11;
            break;
          }
          _context5.t0 = void 0;
          _context5.next = 18;
          break;
        case 11:
          _context5.t1 = ethereum;
          _context5.next = 14;
          return (0, exports.makeNetworkParams)(networkConfig, CELO);
        case 14:
          _context5.t2 = _context5.sent;
          _context5.t3 = [_context5.t2];
          _context5.t4 = {
            method: 'wallet_addEthereumChain',
            params: _context5.t3
          };
          _context5.t0 = _context5.t1.request.call(_context5.t1, _context5.t4);
        case 18:
          _context5.next = 20;
          return _context5.t0;
        case 20:
          _context5.next = 22;
          return (0, exports.addTokensToMetamask)(ethereum, tokens);
        case 22:
          _context5.next = 26;
          break;
        case 24:
          _context5.next = 26;
          return ethereum === null || ethereum === void 0 ? void 0 : ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [{
              chainId: networkConfig.chainId,
              chainName: networkConfig.name,
              rpcUrls: [networkConfig.rpcUrl],
              blockExplorerUrls: [networkConfig.explorer],
              nativeCurrency: networkConfig.nativeCurrency
            }]
          });
        case 26:
          _context5.next = 36;
          break;
        case 28:
          _context5.prev = 28;
          _context5.t5 = _context5["catch"](0);
          code = _context5.t5.code;
          if (!(code === MetamaskRPCErrorCode.AwaitingUserConfirmation)) {
            _context5.next = 35;
            break;
          }
          throw new Error("Please check your Metamask window to add ".concat(networkConfig.name, " to Metamask"));
        case 35:
          throw _context5.t5;
        case 36:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 28]]);
  }));
};
exports.addNetworkToMetamask = addNetworkToMetamask;
function addNetworksToMetamask(ethereum) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return Promise.all(Object.values(NETWORKS).map(function (network) {
            return (0, exports.addNetworkToMetamask)(ethereum, network);
          }));
        case 2:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
}
exports.addNetworksToMetamask = addNetworksToMetamask;
function switchToNetwork(network, ethereum, getChainId) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var _yield$Promise$all5, _yield$Promise$all6, chainId, walletChainId, code;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return Promise.all([getChainId(), getWalletChainId(ethereum)]);
        case 2:
          _yield$Promise$all5 = _context7.sent;
          _yield$Promise$all6 = _slicedToArray(_yield$Promise$all5, 2);
          chainId = _yield$Promise$all6[0];
          walletChainId = _yield$Promise$all6[1];
          if (!(network.chainId !== chainId || network.chainId !== walletChainId)) {
            _context7.next = 28;
            break;
          }
          _context7.prev = 7;
          _context7.next = 10;
          return ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{
              chainId: "0x".concat(network.chainId.toString(16))
            }]
          });
        case 10:
          _context7.next = 12;
          return (0, exports.networkHasUpdated)(getChainId, network.chainId);
        case 12:
          _context7.next = 28;
          break;
        case 14:
          _context7.prev = 14;
          _context7.t0 = _context7["catch"](7);
          code = _context7.t0.code;
          if (!(code === MetamaskRPCErrorCode.UnknownNetwork || code === MetamaskRPCErrorCode.UnrecognizedChainID)) {
            _context7.next = 23;
            break;
          }
          _context7.next = 20;
          return (0, exports.addNetworkToMetamask)(ethereum, network);
        case 20:
          return _context7.abrupt("return", switchToNetwork(network, ethereum, getChainId));
        case 23:
          if (!(code === MetamaskRPCErrorCode.AwaitingUserConfirmation)) {
            _context7.next = 27;
            break;
          }
          return _context7.abrupt("return");
        case 27:
          throw _context7.t0;
        case 28:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[7, 14]]);
  }));
}
exports.switchToNetwork = switchToNetwork;
var sleep = function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};
var SLEEP = 500;
var MAX_WAIT_MINUTES = 3;
var MAX_RETRY = Math.round(MAX_WAIT_MINUTES * 1000 / SLEEP);
// Hacky workaround to wait for the network to change.\
var networkHasUpdated = function networkHasUpdated(getChainId, expectedChainId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    var attempts, isNetworkUpdated, chainId;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          attempts = 0;
          isNetworkUpdated = false;
        case 2:
          if (isNetworkUpdated) {
            _context8.next = 16;
            break;
          }
          attempts++;
          if (!(attempts >= MAX_RETRY)) {
            _context8.next = 6;
            break;
          }
          throw new Error('Network did not change');
        case 6:
          _context8.next = 8;
          return getChainId();
        case 8:
          chainId = _context8.sent;
          if (!(chainId === expectedChainId)) {
            _context8.next = 12;
            break;
          }
          isNetworkUpdated = true;
          return _context8.abrupt("return", true);
        case 12:
          _context8.next = 14;
          return sleep(SLEEP);
        case 14:
          _context8.next = 2;
          break;
        case 16:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
};
exports.networkHasUpdated = networkHasUpdated;
function getWalletChainId(ethereum) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    var walletChainId;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          if (!ethereum.chainId) {
            _context9.next = 4;
            break;
          }
          _context9.t0 = ethereum.chainId;
          _context9.next = 7;
          break;
        case 4:
          _context9.next = 6;
          return ethereum.request({
            method: 'eth_chainId'
          });
        case 6:
          _context9.t0 = _context9.sent;
        case 7:
          walletChainId = _context9.t0;
          return _context9.abrupt("return", parseInt(walletChainId, 16));
        case 9:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
}
exports.getWalletChainId = getWalletChainId;